module.exports = __webpack_public_path__ + "static/img/3-bg.e9c1f28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/3-bg.png
// module id = 9JOm
// module chunks = 1